import { render, staticRenderFns } from "./LoadRateMatrix.vue?vue&type=template&id=6cebec28&scoped=true&"
import script from "./LoadRateMatrix.vue?vue&type=script&lang=js&"
export * from "./LoadRateMatrix.vue?vue&type=script&lang=js&"
import style0 from "./LoadRateMatrix.vue?vue&type=style&index=0&id=6cebec28&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cebec28",
  null
  
)

export default component.exports